const PREFIX = 'recon.includeGroupInventory.';

export function storageKey(database) {
	return `${PREFIX}${database || 'unknown'}`;
}

export function getIncludeGroupInventory(database) {
	try {
		const value = localStorage.getItem(storageKey(database));
		return value === 'true';
	} catch (e) {
		return false;
	}
}

export function setIncludeGroupInventory(database, value) {
	const next = value === true;
	try {
		localStorage.setItem(storageKey(database), next ? 'true' : 'false');
	} catch (e) {
		// ignore quota / private mode
	}
	return next;
}
